import React, {useState} from "react"
import {Box, Button, Collapse, Divider, Paper, Stack, Typography} from "@mui/material";

export default function DebugMenu(props: any) {

    const {testMode, fieldDisplay, template, debug} = props
    const [open, setOpen] = useState<boolean>(false)

    if (!testMode) return null

    return (
        <>
            <Box sx={{
                position: "absolute",
                bottom: 15,
                left: 15,
            }}>
                <Paper variant={"outlined"} sx={{p: 2, borderRadius: 5}}>
                    <Typography variant={"body2"} onClick={() => setOpen(!open)} align={"center"} fontWeight={700} sx={{ cursor: "pointer" }}>
                        Debug Menu
                    </Typography>
                    <Collapse in={open}>
                        <Stack spacing={1} sx={{ pt: 3 }}>
                            <Button size={"small"} variant={"outlined"} onClick={() => console.log(fieldDisplay)}>
                                Log Field Display
                            </Button>
                            <Divider />
                            <Button size={"small"} variant={"contained"} onClick={() => debug().propagateTestData()}>
                                Go Secret Story
                            </Button>
                            <Button size={"small"} variant={"contained"} onClick={() => debug().propagateStarAc()}>
                                Go Star Ac
                            </Button>
                            <Divider />
                            <Button size={"small"} variant={"outlined"} onClick={() => debug().switchError()}>
                                Error
                            </Button>
                            <Button size={"small"} variant={"outlined"} onClick={() => debug().switchLoading()}>
                                Loading
                            </Button>
                            <Button size={"small"} variant={"outlined"} onClick={() => debug().switchAppState()}>
                                Switch App State
                            </Button>
                            <Button size={"small"} variant={"outlined"} onClick={() => debug().navigateToProperURL()}>
                                Nav To URL
                            </Button>
                            <Divider />
                            {!!template && <Typography mt={2} variant={"caption"}><b>Template:</b> {template}</Typography>}
                            {!!fieldDisplay.message && <Typography mt={2} variant={"caption"}><b>Message:</b> {fieldDisplay.message}<br/></Typography>}
                            {!!fieldDisplay.phone && <Typography mt={2} variant={"caption"}><b>Phone:</b> {fieldDisplay.phone}</Typography>}
                        </Stack>
                    </Collapse>
                </Paper>
            </Box>
        </>
    )
}